import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';

export default function ReminderPropertyDialog(props) {
  const [open] = React.useState(true);
  return (
    <div>
      <Dialog
        open={open}
        onClose={props.handleReminderClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        {/* <DialogTitle id="alert-dialog-title">Property Address and City is already exists, Still Do you want to Continue!
         Press Ok </DialogTitle>         */}
         <DialogTitle id="alert-dialog-title">Property Address already exists.</DialogTitle>  
        <DialogActions>
          <Button onClick={props.handleReminderClose} color="primary">
            Cancel
          </Button>
          <Button onClick={props.handleReminderAccept} color="primary" autoFocus>
            Proceed Anyways
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
